import React from "react";
import {classNames} from "../../../util/util-helpers";
import {formatMoney} from "../../../util/util-formaters";


export default function FieldMoney({item = {}, className, isNegativeAllowed, onFocus, onChange, disabled, translate, prefix, suffix}) {
    if (!item.props) {
        item.props = {}
    }

    const removeCommas = (e) => {
        e.target.value = e.target.value.replace(/,/g, '');

        e.target.select();

        if (onFocus) {
            onFocus();
        }
    }

    const addCommas = (e) => {
        let value = e.target.value;
        if (value?.toString()?.split('.')?.length > 2) {
            value = value?.toString()?.split('.');
            value = value[0] + "." + value[1];
        }

        value = formatMoney(value);
        onChange(item.name, value);

        if (typeof item?.props?.onBlur === 'function') {
            item?.props?.onBlur();
        }
    }

    const handleInputChange = (e) => {
        let hasNegativeValue = false;
        let value = e.target.value;

        if (isNegativeAllowed && value[0] === "-") {
            hasNegativeValue = true;
        }

        let original = value.toString().split(".");

        if (original[1] && original[1].length > 2) {
            value = original[0] + (original[1] ? "." + original[1].charAt(0) + original[1].charAt(1) : "");
        }

        value = value.replace(/[^0-9.]/g, '');
        value = value.replace(/,/g, "");

        if (hasNegativeValue) {
            value = "-" + value;

            if (value === 0) {
                value = '-';
            }
        }

        onChange(item.name, value)
    }

    return (
        <React.Fragment>
            <div className={classNames("relative", (prefix || suffix) && "flex")}>
                {!!prefix && (
                    <span className="flex justify-center items-center px-3 bg-tm-gray-100 border border-r-0 border-tm-gray-300 text-sm text-gray-500 rounded-l-btn min-w-[36px]">
                        {prefix}
                    </span>
                )}

                <div className={classNames("relative", (prefix || suffix) && "flex-1 min-w-0")}>
                    <input
                        id={item.props.id ?? item.name}
                        onChange={handleInputChange}
                        onBlur={addCommas}
                        onFocus={removeCommas}
                        name={item.name}
                        value={item.value}
                        placeholder={item?.props?.placeholder}
                        disabled={item.disabled || disabled}
                        autoFocus={item.props.autofocus}
                        className={
                            classNames(
                                className ?? item?.metadata?.className ?? item?.props?.className ?? "form-control",
                                suffix ? "rounded-r-none" : undefined,
                                prefix ? "rounded-l-none" : undefined,
                                item.errorMessage ? item?.metadata?.errorClass ?? "is-invalid" : undefined
                            )
                        }
                    />
                </div>

                {!!suffix && (
                    <span className="flex justify-center items-center px-3 bg-tm-gray-100 border border-l-0 border-tm-gray-300 text-sm text-gray-500 rounded-r-btn min-w-[36px]">
                        {suffix}
                    </span>
                )}
            </div>

            {item.errorMessage && (
                <div className={"text-red-600 font-semibold"}>
                    {!!translate && (
                        item.errorMessage.reduce((memo, it) => {
                            if (it.key) {
                                return translate(it.key, it.values) + (memo ? "," + memo : "")
                            }
                            return translate(it) + (memo ? "," + memo : "")
                        }, "")
                    )}
                    {!translate && (
                        <span>Amount is not valid*</span>
                    )}
                </div>
            )}
        </React.Fragment>
    )
}

